<sh-card>
  <sh-text size="header-2" color="primary"
    >{{ 'label.docBoxPanel' | translate }}
    <ng-container *ngIf="(docBoxEntries.data$ | async)?.documents as documents"
      ><span style="font-weight: 100">{{ topDocCountDisplay$ | async }}</span>
    </ng-container>
  </sh-text>
  <api-call-gate [apiCall]="docBoxEntries" loadingLabel="loading records..">
    <ng-template #lastSuccessfulData let-docs>
      <ng-container *ngIf="docs.documents.length === 0">
        <div class="empty">
          <sh-icon icon="list-viewmode" disabled style="margin: auto"></sh-icon>
          <br />
          No records found
        </div>
      </ng-container>
      <ng-container *ngIf="docs.documents.length > 0">
        <div
          *ngFor="let doc of topDocs$ | async; let i = index"
          class="panel-entry"
          t_entry
          [attr.t_id]="'id' + doc.identifier"
          (click)="download([doc])"
          (keyup.enter)="download([doc])"
          tabindex="0"
        >
          <div class="title">
            <ng-container *ngIf="!downloads.has(doc.identifier)">
              <sh-icon id="download" button icon="download"></sh-icon>
            </ng-container>
            <ng-container *ngIf="downloads.get(doc.identifier) as download">
              <ng-container
                *ngIf="download.loading$ | async; else downloadComplete"
              >
                <sh-spinner size="s"></sh-spinner>
              </ng-container>
              <ng-template #downloadComplete>
                <sh-icon id="checkmark" button icon="checkmark"></sh-icon>
              </ng-template>
            </ng-container>
            <span class="truncated-text" t_name>{{ doc.fileName }}</span>
          </div>
          <div class="dates">
            <div>
              <ng-container *ngIf="doc.startDate">
                {{ doc.startDate | localizedDate }}
              </ng-container>
              <ng-container *ngIf="doc.endDate">
                {{ doc.endDate | localizedDate }} (End)
              </ng-container>
            </div>
            <div style="flex: 1 0"></div>
            <div class="tag">
              {{ doc.documentType }}
            </div>
          </div>
        </div>
        <sh-button
          style="margin-left: auto"
          color="secondary"
          size="auto"
          (click)="navigateToDocBox()"
          label="All DocBox Records"
        ></sh-button>
      </ng-container>
    </ng-template>
  </api-call-gate>
</sh-card>
